import * as React from 'react';
// import { IQRCodeModalOptions, IAppRegistry } from '@walletconnect/types';
import {
  isMobile,
  formatIOSMobile,
  saveMobileLinkInfo,
  getMobileLinkRegistry,
  getWalletRegistryUrl,
  formatMobileRegistry,
} from '@walletconnect/browser-utils';

import { TextField, Box, Typography } from '@mui/material';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
import Header from './Header';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import QRCodeDisplay from './QRCodeDisplay';

import { TextMap } from '../types';
import { KLIP_MODAL_ID } from '../constants';
import { ChangeEvent, useState } from 'react';
import LogoTopPort from '~/assets/img/i_topport.svg';
import LogoTopPortLight from '~/assets/img/i_topport_light.svg';
import { Trans, useTranslation } from 'react-i18next';
import NumericKeypad from '~/components/common/NumericKeypad';
import { useThemeMode } from '~/components/common/AppStoreStyle';
import _ from 'lodash';
import CloseIcon from '~/assets/img/i_x_w.svg';
import CloseIconLight from '~/assets/img/i_x_b_02.svg';

interface ModalProps {
  text: TextMap;
  uri: string;
  onClose: any;
  qrcodeModalOptions?: any;
  buttonTitle?: string;
}

function Modal({
  text,
  uri,
  onClose,
  buttonTitle = 'Sign Up',
  qrcodeModalOptions,
}: ModalProps) {
  const mobile = isMobile();

  const [loading, setLoading] = React.useState(false);
  const [fetched, setFetched] = React.useState(false);
  const [displayQRCode, setDisplayQRCode] = React.useState(!mobile);
  const [hasSingleLink, setHasSingleLink] = React.useState(false);
  const [singleLinkHref, setSingleLinkHref] = React.useState('');
  const [errorMessage, setErrorMessage] = React.useState('');
  // const [links, setLinks] = React.useState<IMobileRegistryEntry[]>([]);
  const [links, setLinks] = React.useState<any>([]);

  const [token, setToken] = React.useState('');
  const [inputs, setInputs] = useState(['', '', '', '', '', '']);
  const [isCorrectCode, setIsCorrectCode] = useState(true);
  const { t } = useTranslation();
  const { isDarkMode } = useThemeMode();

  const displayProps = {
    mobile,
    text: text,
    uri: uri,
    qrcodeModalOptions: qrcodeModalOptions,
  };

  const handleAbcTokenChange = (event: ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    const { value } = event.target;
    const numericValue = value.replace(/\D/g, '').slice(0, 6);
    // console.log(value);
    setToken(numericValue);
  };

  const handlePasteFromClipboard = () => {
    navigator.clipboard.readText().then((text) => {
      setToken(text);
    });
  };

  const getLinksIfNeeded = () => {
    React.useEffect(() => {
      const initLinks = async () => {
        if (fetched || loading || links.length > 0) {
          return;
        }
        setLoading(true);
        try {
          const url =
            qrcodeModalOptions && qrcodeModalOptions.registryUrl
              ? qrcodeModalOptions.registryUrl
              : getWalletRegistryUrl();
          const registryResponse = await fetch(url);
          const registry = (await registryResponse.json()).listings;
          const platform = mobile ? 'mobile' : 'desktop';
          const _links = getMobileLinkRegistry(
            formatMobileRegistry(registry, platform),
            []
          );
          setLoading(false);
          setFetched(true);
          setErrorMessage(!_links.length ? text.no_supported_wallets : '');
          setLinks(_links);
          const hasSingleLink = _links.length === 1;
          if (hasSingleLink) {
            setSingleLinkHref(formatIOSMobile(uri, _links[0]));
            setDisplayQRCode(true);
          }
          setHasSingleLink(hasSingleLink);
        } catch (e) {
          setLoading(false);
          setFetched(true);
          setErrorMessage(text.something_went_wrong);
          console.error(e); // eslint-disable-line no-console
        }
      };
      initLinks();
    });
  };

  getLinksIfNeeded();

  // const handleInputChange = (index: number, value: string) => {
  //   if (value.length > 1) {
  //     value = value.slice(0, 1);
  //   }
  //   if (/^\d{0,1}$/.test(value)) {
  //     const newInputs = [...inputs];
  //     newInputs[index] = value;
  //     setInputs(newInputs);
  //     if (newInputs.length === 6) {
  //       const hasEmptyElement = newInputs.some((element) => element === '');
  //       if (!hasEmptyElement) {
  //         setValue('otp', newInputs.join(''));
  //       } else {
  //         setValue('otp', '');
  //       }
  //     }

  //     if (index < inputs.length - 1 && value !== '') {
  //       const nextInput = document.getElementById(
  //         `input-${index + 1}`
  //       ) as HTMLInputElement;
  //       if (nextInput) {
  //         nextInput.removeAttribute('disabled');
  //         nextInput.focus();
  //       }
  //     }
  //   } else {
  //     value = '';
  //   }
  // };

  // const handleKeypadPress = (key: any) => {
  //   if (key === 'delete') {
  //     const lastNonEmptyIndex = inputs
  //       .map((value, index) => ({ value, index }))
  //       .reverse()
  //       .find(({ value }) => value !== '')?.index;

  //     if (lastNonEmptyIndex !== undefined) {
  //       handleInputChange(lastNonEmptyIndex, '');
  //     }
  //   } else if (key !== 'random') {
  //     const firstEmptyIndex = inputs.indexOf('');
  //     if (firstEmptyIndex !== -1) {
  //       handleInputChange(firstEmptyIndex, key);
  //     }
  //   }
  // };
  const handleKeypadPress = (key: string) => {
    if (key === 'delete') {
      const lastIndex = _.findLastIndex(inputs, (v) => v !== '');
      if (lastIndex !== -1) {
        const newInputs = [...inputs];
        newInputs[lastIndex] = '';
        setInputs(newInputs);
      }
    } else if (key !== 'random' && /^\d$/.test(key)) {
      const firstEmptyIndex = inputs.indexOf('');
      if (firstEmptyIndex !== -1) {
        const newInputs = [...inputs];
        newInputs[firstEmptyIndex] = key;
        setInputs(newInputs);
      }
    }
  };

  return (
    <div
      id={KLIP_MODAL_ID}
      className="klip-qrcode__base animated fadeIn Modal detail-nft-overlay"
    >
      <div className="qr-modal" onClick={(e) => e.stopPropagation()}>
        {isDarkMode ? (
          <img className="i" src={LogoTopPort} alt="top port" />
        ) : (
          <img className="i" src={LogoTopPortLight} alt="top port" />
        )}

        <div className="wrap-qr-modal">
          <div className="header">{t('Enter Your Pin Code')}</div>
          <button
            className="btn btn-close-icon"
            onClick={() => onClose(inputs.join(''))}
          >
            {isDarkMode ? (
              <img className="i close-icon" src={CloseIcon} alt="close" />
            ) : (
              <img className="i" src={CloseIconLight} alt="close" />
            )}
          </button>
          <div className="line-banner"></div>
          <div className="body">
            <h4 className="text-head">
              {isCorrectCode ? (
                <Trans i18nKey="enter_6_digit_number">
                  Please enter the 6-digit number
                  <br />
                  you will use to approve wallet transactions.
                </Trans>
              ) : (
                t('Please confirm your PIN entering it again.')
              )}
            </h4>
            <div className="wrap-invalid-code">
              <div className="wrap-number-code">
                {inputs.map((value, index) => (
                  <input
                    key={index}
                    id={`input-${index}`}
                    type="number"
                    inputMode="none" // Disable OS keyboard
                    maxLength={1}
                    pattern="[0-9]*"
                    value={value}
                    disabled={true} // Disable input field
                    // onChange={(e) => handleInputChange(index, e.target.value)}
                    // onKeyUp={(e) => handleKeyPress(e, index)}
                    className={`box-input-code ${
                      !isCorrectCode ? 'border-red' : 'border-input-code'
                    }`}
                    autoFocus={index === 0}
                    onInput={(e) => {
                      const inputElement = e.target as HTMLInputElement;
                      const inputValue = inputElement.value;
                      if (isNaN(parseInt(inputValue))) {
                        inputElement.value = '';
                      }
                    }}
                  />
                ))}
              </div>
              {!isCorrectCode && (
                <p className="text-invalid-code">
                  {t('Invalid code. Please enter the correct code.')}
                </p>
              )}
            </div>
            <NumericKeypad onKeyPress={handleKeypadPress} />
            <button
              className={`btn-sign-up ${
                inputs.every((v) => v) ? '' : 'disabled'
              }`}
              onClick={() => onClose(inputs.join(''))}
              disabled={inputs.some((v) => v === '')}
            >
              {t(`${buttonTitle}`)}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Modal;
